<template>
  <VLayout
    :title="$t('patientdata.personal_data')"
    :showButtonReturn="true"
    :showButtonHome="true"
  >

    <b-alert show variant="danger" v-if="!getUuidPatientSelected">
      {{ $t('patientdata.first_data_fill_alert') }}
    </b-alert>

    <PatientDataForm v-on:patient-data-updated="doRedirect" />
    <VButtonGroup />
  </VLayout>
</template>

<script>
import { mapGetters } from "vuex";
import VLayout from "@/layouts/Default";
import PatientDataForm from "@/components/PatientDataForm";
import VButtonGroup from "@/components/VButtonGroup";

export default {
  components: {
    VLayout,
    PatientDataForm,
    VButtonGroup,
  },
  props: {
    after_save_redirect: {
      type: Object,
      default: function() {
        return { name: "userhome" };
      },
    },
  },
  computed: {
    ...mapGetters("naturalperson", ["getUuidPatientSelected"]),
  },
  methods: {
    doRedirect(data) {
      let to = this.after_save_redirect;
      to["params"] = { pt_uuid: data.uuid };
      this.$router.push(to);
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        patientdata: {
          first_data_fill_alert:
            "Please fill in your personal information to complete your registration.",
          personal_data: "Personal Data",
        },
      },
    },
  },
};
</script>

